// Correspondance entre les entrées de navigation et ce que la plateforme sait
// réellement faire aujourd'hui. Une section sans donnée affiche un état
// « sans objet » explicite plutôt qu'un tableau de bord fabriqué.

export const LIVE = new Set([
  "dashboard", "users", "sessions", "audit", "security",
  "flags", "incidents", "exports", "gdpr", "impersonation", "roles", "permissions",
]);

// Raison affichée pour chaque section sans objet : elle doit dire *pourquoi*,
// pas seulement « bientôt ».
export const NOT_APPLICABLE = {
  orgs: "Perform n'a pas encore de notion d'organisation : chaque compte est individuel. Les espaces d'équipe figurent sur la feuille de route.",
  domains: "Les domaines servent à la vérification d'entreprise et au SSO, deux fonctionnalités qui n'existent pas encore.",
  analytics: "Aucun outil de mesure d'audience n'est installé, par choix. Les compteurs réels sont sur le tableau de bord.",
  system: "Nous n'avons pas de supervision continue. L'état des services publics reste la source de vérité.",
  subscriptions: "Aucun abonnement : Perform facture à la séance, et les paiements ne sont pas activés.",
  payments: "Les paiements ne sont pas activés. Aucune transaction n'a jamais été traitée.",
  invoices: "Aucune facture émise : il n'y a eu aucun encaissement.",
  refunds: "Aucun remboursement possible tant qu'aucun paiement n'a été encaissé.",
  plans: "Le modèle tarifaire est publié mais n'est pas encore configurable : il n'y a pas d'offre à administrer.",
  features: "Les fonctionnalités se pilotent par feature flags. Cette section fera le lien quand il y aura plus d'un environnement.",
  experiments: "Aucun test A/B en cours. L'audience est trop faible pour qu'un résultat soit significatif.",
  releases: "Les déploiements passent par Railway et le journal des nouveautés. Aucun outil de version dédié.",
  sso: "Ni SAML ni OIDC. La connexion se fait uniquement par lien à usage unique.",
  scim: "Aucun provisionnement d'annuaire : il n'y a pas d'organisations à synchroniser.",
  "api-security": "L'API n'expose ni clé ni jeton porteur : la sécurité passe par la session et la vérification d'origine. Voir le Centre de sécurité.",
  tickets: "Le support passe par e-mail. Aucun outil de billetterie n'est branché.",
  "customer-activity": "L'activité par compte est visible depuis la fiche d'un utilisateur.",
  api: "Les métriques d'API ne sont pas collectées : aucune instrumentation n'est en place.",
  "api-keys": "Il n'existe pas de clé d'API. L'authentification se fait par session.",
  oauth: "Aucune application OAuth : Perform n'est pas fournisseur d'identité.",
  webhooks: "Aucun webhook sortant n'est implémenté.",
  integrations: "Aucune intégration tierce n'est disponible à ce jour.",
  "ai-usage": "Aucune fonctionnalité d'IA n'est active : aucune requête n'est envoyée à un fournisseur de modèle.",
  "ai-models": "Aucun modèle n'est configuré, donc rien à administrer.",
  "ai-costs": "Aucun coût d'IA : aucune requête n'est émise.",
  "ai-safety": "Sans requête IA, il n'y a ni incident de sûreté ni signal d'abus à examiner.",
  storage: "Le stockage se limite aux photos de profil. Aucun quota n'est administré.",
  retention: "Les durées de conservation sont figées dans le code et documentées, pas encore configurables.",
  status: "La page d'état publique sonde l'API en direct. Elle n'est pas pilotée depuis ici.",
  jobs: "Aucune file de tâches : tous les traitements sont synchrones.",
  queues: "Aucune file d'attente n'est déployée.",
  errors: "Aucun agrégateur d'erreurs n'est branché. Les traces vivent dans les journaux Railway.",
  admins: "La liste des administrateurs se gère depuis la fiche de chaque utilisateur.",
  general: "Les réglages généraux vivent dans les variables d'environnement, pas en base.",
  "settings-security": "Les paramètres de sécurité sont figés dans le code : ils ne sont pas modifiables à chaud, par choix.",
  notifications: "Aucune notification administrateur n'est émise : il n'y a pas de canal d'alerte.",
};

export const TITLES = {
  dashboard: ["Tableau de bord", "Compteurs réels de la plateforme."],
  users: ["Utilisateurs", "Comptes, rôles et sessions."],
  sessions: ["Sessions", "Connexions actives, révocables."],
  audit: ["Journal d'audit", "Chaque action sensible, succès comme refus."],
  security: ["Centre de sécurité", "Ce qui est mesurable aujourd'hui."],
  flags: ["Feature flags", "Activation progressive des fonctionnalités."],
  incidents: ["Incidents", "Suivi et communication."],
  exports: ["Exports", "Demandes d'extraction de données."],
  gdpr: ["Demandes RGPD", "Accès et effacement, échéance à 30 jours."],
  impersonation: ["Emprunt d'identité", "Voir l'application comme un utilisateur."],
  roles: ["Rôles", "Huit rôles, vingt-sept permissions."],
  permissions: ["Permissions", "Matrice complète rôle par permission."],
};
